<template>
  <component
    ref="input"
    :is="innerComponent"
    v-model="model"
    :placeholder="placeholder"
    :options="innerOptions"
    :readonly="readonly"
    :disabled="disabled"
    @app-event="onAppEvent"/>
</template>

<style scoped>
.mini {
  max-width: 75px;
}
.short {
  max-width: 140px;
}
.medium {
  max-width: 220px;
}
.long {
  max-width: 300px;
}
</style>

<script>
/* eslint-disable semi */
import { Component, Prop } from 'vue-property-decorator';
import AppComponent from '@/app/AppComponent';

import mapping from './type_mapping'

@Component
export default class AppInput extends AppComponent {
  @Prop({ required: true })
  type;

  @Prop({ required: true })
  value;

  @Prop({ required: false })
  placeholder;

  @Prop({ required: false })
  options;

  @Prop({ required: false, default: false })
  readonly;

  @Prop({ required: false, default: false })
  disabled;

  /**
   * v-model対応
   */
  get model () {
    return this.value;
  }

  /**
   * v-model対応
   */
  set model (value) {
    this.$emit('input', value);
  }

  data () {
    return {
      innerComponent: null,
      innerOptions: null
    }
  }

  created () {
    const key = (this.type in mapping) ? this.type : 'default';
    const conponentInfo = mapping[key];
    const options = (conponentInfo.length > 0) ? conponentInfo[1] : {};

    this.innerComponent = conponentInfo[0];
    this.innerOptions = {...options, ...this.options};
  }

  focus () {
    if (this.$refs.input && this.$refs.input.focus) {
      this.$refs.input.focus();
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/parts/AppInput.vue